import React, { Component } from "react";
import Chart from "react-apexcharts";
import MS from '../../../../commons/services/Moment'
import styled from "styled-components";
import SelectBox from "../../../../commons/components/SelectBox";
import DateCustom from "../../../../commons/components/DateCustom";
import { getChartOptions } from "./graphModel";
import { withTranslation } from "react-i18next";

class Graph extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date: MS.current("YY-MM-DD"),
    }
  }
  render() {
    const { 
      title, 
      onChangeSearch, 
      date, 
      categories, 
      xAxisTitle = "", 
      yAxisTitle = "", 
      chartId = "",
      selectOptions1 = [],
      onChangeSearchTime,
      defaultSelectValue1,
      series = [],
      t
    } = this.props;
    return (
      <GraphContainer>
        <GraphHeader>
          <div>
            <strong>{t('key492')}</strong>
            <span>{t('key493')} {'20'}{t('key494')}</span>
          </div>
          {
            onChangeSearch && (
              <form onSubmit={(event) => event.preventDefault()}>
                {/* 기간 설정 -> 데이터가 너무 많음 */}
                {/* <DateRange 
                  handleDateChange={onChangeSearch}
                /> */}
                {/* 단일 기간 */}
                <DateCustom 
                  name="date"
                  value={date}
                  handleDateChange={onChangeSearch}
                />
                <SelectBox 
                  name="moduleCompanyId"
                  default={defaultSelectValue1 || "선택"}
                  items={selectOptions1}
                  handleSelectChange={(value) => onChangeSearchTime(value)}
                />
                {/* <SelectBox 
                  default="선택"
                  items={[]}
                /> */}
              </form>
            )
          }
        </GraphHeader>
        <GraphTitleContainer>
          <h4>{title}</h4>
        </GraphTitleContainer>
        <Chart 
          options={getChartOptions(
            {
              chartId: chartId,
              categories: categories,
              xAxisTitle: xAxisTitle,
              yAxisTitle: yAxisTitle,
            }
          )}
          series={series}
          type="line"
          height={350}
        />
      </GraphContainer>
    );
  }
}
const GraphContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin: 30px 0;
`;
const GraphHeader = styled.div`
  width: 100%;
  height: 49px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  
  & strong {
    font-size: 15px;
    font-weight: 700;
    margin-right: 10px;
  }
  & span {
    font-size: 15px;
    font-weight: 400;
    color: #888E98;
  }
  & form {
    display: flex;
    flex-direction: row;
    gap: 12px;
  }
`;
const GraphTitleContainer = styled.div`
  width: 100%;
  height: 48px;
  border-radius: 12px;
  background-color: #F2F3F5;
  padding: 10px 20px;

  & > h4 {
    line-height: 28px;
    font-size: 16px;
    font-weight: 400;
  }
`;

export default withTranslation()(Graph);
